import React, { FC } from 'react'
import Markdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'
import rehypeSanitize from 'rehype-sanitize'
import remarkBreaks from 'remark-breaks'
import remarkGfm from 'remark-gfm'

import styles from './MarketAnalysisTypography.module.css'

export interface MarketAnalysisMarkdownRendererProps {
  content: string
  className?: string
}

const marketAnalysisComponents = {
  h1: ({ children }: any) => <h1 className={styles.h1}>{children}</h1>,
  h2: ({ children }: any) => <h2 className={styles.h2}>{children}</h2>,
  h3: ({ children }: any) => <h3 className={styles.h3}>{children}</h3>,
  h4: ({ children }: any) => <h4 className={styles.h3}>{children}</h4>,
  h5: ({ children }: any) => <h5 className={styles.h3}>{children}</h5>,
  h6: ({ children }: any) => <h6 className={styles.h3}>{children}</h6>,
  p: ({ children }: any) => <p className={styles.paragraph}>{children}</p>,
  strong: ({ children }: any) => <strong>{children}</strong>,
  em: ({ children }: any) => <em>{children}</em>,
  ul: ({ children }: any) => <ul className={styles.list}>{children}</ul>,
  ol: ({ children }: any) => <ol className={styles.list}>{children}</ol>,
  li: ({ children }: any) => <li className={styles.listItem}>{children}</li>
}

const MarketAnalysisMarkdownRenderer: FC<MarketAnalysisMarkdownRendererProps> = ({ content, className }) => {
  const wrapperClasses = [styles.marketAnalysisRoot, className].filter(Boolean).join(' ')

  return (
    <div className={wrapperClasses}>
      <Markdown remarkPlugins={[remarkGfm, remarkBreaks]} rehypePlugins={[rehypeRaw, rehypeSanitize]} components={marketAnalysisComponents}>
        {content}
      </Markdown>
    </div>
  )
}

export default MarketAnalysisMarkdownRenderer
